import { moduleName as recordModuleName } from "../../../records";
import angular from "angular";
import { vsModuleName as shareContractModuleName } from "../../../Contract/shared";
import { machineConfigurationConfig } from "./machineConfiguration";

export const vsModuleName = "SlotTrak.Machine.Config";

angular
  .module(vsModuleName, [recordModuleName, shareContractModuleName])
  .config(machineConfigurationConfig);
